'use client';

import dynamic from 'next/dynamic';

//* Styles
import InvestmentLegislationTemplateStyle from './style';

//* Components
import NewHeroSection from '../../BusinessRegistration/components/NewHeroSection';
const Items = dynamic(() => import('../components/Items'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FdiLegislationSection = dynamic(() => import('../components/FdiLegislationSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const PartnershipSection = dynamic(() => import('../components/PartnershipSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const InvestmentLegislationTemplate = ({ pageData }) => {
	const { content, faqs } = pageData;
	const { hero, fdi_legislation, partnership } = content;

	return (
		<InvestmentLegislationTemplateStyle>
			<NewHeroSection {...hero} />

			<Items items={hero.items} />

			<FdiLegislationSection {...fdi_legislation} />

			<PartnershipSection {...partnership} />

			<FAQSection items={faqs} />
		</InvestmentLegislationTemplateStyle>
	);
};

export default InvestmentLegislationTemplate;
